import KPIRow from './KPIRow';
import AnnualPerformanceTable from './AnnualPerformanceTable';
import BenchmarkBars from './BenchmarkBars';
import RevenueForecastChart from './RevenueForecastChart';
import DivisionHealth from './DivisionHealth';
import CashSnapshot from './CashSnapshot';
import RevenuePace from './RevenuePace';
import TaxSeasonProgress from './TaxSeasonProgress';
import PipelineSnapshot from './PipelineSnapshot';
import AIWatchlist from './AIWatchlist';
import { useFinancialData } from '../../context/FinancialDataContext';

export default function Dashboard({ monthlyImpact }) {
  const { annualSummary, targets, kpi, editableByClass, allPLData, global2026Monthly } = useFinancialData();

  const priorYearGlobal = allPLData.global?.['2025'] || null;
  const priorYearByClass = {
    bwm: allPLData.bwm?.['2025'] || null,
    bts: allPLData.bts?.['2025'] || null,
    bia: allPLData.bia?.['2025'] || null,
  };

  return (
    <div>
      {/* KPI Cards */}
      <KPIRow kpi={kpi} targets={targets} annualSummary={annualSummary} />

      {/* Monthly Revenue Chart */}
      <RevenueForecastChart global2026Monthly={global2026Monthly} priorYearData={priorYearGlobal} />

      {/* Revenue Pace + Tax Season + Pipeline + Cash Position */}
      <div className="grid grid-cols-4 gap-4 mb-6">
        <RevenuePace global2026Monthly={global2026Monthly} />
        <TaxSeasonProgress global2026Monthly={global2026Monthly} />
        <PipelineSnapshot />
        <CashSnapshot monthlyImpact={monthlyImpact} />
      </div>

      {/* Division Health */}
      <div className="mb-6">
        <DivisionHealth
          editableByClass={editableByClass}
          priorYearByClass={priorYearByClass}
        />
      </div>

      {/* Benchmarks + Annual Performance */}
      <div className="grid grid-cols-[350px_1fr] gap-4 mb-6">
        <BenchmarkBars annualSummary={annualSummary} targets={targets} />
        <AnnualPerformanceTable annualSummary={annualSummary} targets={targets} />
      </div>

      {/* Key Signals (AI-powered) */}
      <div className="mb-6">
        <AIWatchlist />
      </div>
    </div>
  );
}
